export async function init() {
    cartListener();
}

/**
 * De "Bestellen"-knop linkt direct naar de checkout met ?add-to-cart=<id>;
 * WooCommerce voegt het product toe bij het laden. Hier houden we alleen
 * href en prijs in sync met de gekozen variant.
 */
function cartListener() {
    const orderCard = document.querySelector(".order-card");
    if (!orderCard) return;

    const tabs = orderCard.querySelectorAll(".price-option-tab");
    const button = orderCard.querySelector(".order-button");
    const priceDisplay = orderCard.querySelector(".price-display");
    const priceDisplayYear = orderCard.querySelector(".price-display-year");

    if (!button) return;

    const checkoutUrl = button.getAttribute("data-checkout-url");

    tabs.forEach(function (tab) {
        tab.addEventListener("change", function () {
            const variationId = tab.value;
            button.setAttribute("data-product_id", variationId);
            button.setAttribute("href", checkoutUrl + "?add-to-cart=" + variationId);

            if (priceDisplay) {
                priceDisplay.textContent = tab.getAttribute("data-price") ?? "";
            }

            if (priceDisplayYear) {
                priceDisplayYear.textContent = tab.getAttribute("data-price-year") ?? "";
            }
        });
    });
}
